
import { clientHTTP } from './clientHTTP';
export const GetAllSecteurs= async () => {
        console.log("GetAllSecteurs ")    
        const {data}= await clientHTTP.post(`/api/sec/all`)
        console.log('DbServices => GetAllSecteurs => data', data)
      return data;
    };